import React, { Fragment } from "react";
import Root from "./Root";
import ReactDOM from "react-dom/client";
import { history } from "./app/store/configureStore";
import store from "./app/store";
import reportWebVitals from "./reportWebVitals";
import setupAxios from "./app/config/axios";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import "./index.scss";

const stripePromise = loadStripe(
  String(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)
);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

setupAxios();

const AppContainer = Fragment;

root.render(
  <AppContainer>
    <Elements stripe={stripePromise}>
      <Root store={store} history={history} />
    </Elements>
  </AppContainer>
);

reportWebVitals();
